import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const ElectricCarsSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="electric-cars-submissions"
    title="התחייבות עובד לטעינה ושימוש ברכב חשמלי - צמודים"
    emptyLabel="אין הגשות להצגה"
    formPageUrl="https://rafael-car-show.co.il/commitment-electric-cars"
  />
);

export default ElectricCarsSubmissionsTable;
